import { Product } from "../types/product";


export const mapOracleRowToProducto = (row: any): Product => ({
    productCode: row.NO_ARTI,
    codFamily: row.CODFAMILIA,
    codLine: row.CODLINEA,
    productName: row.NOMBRE,
    productDescription: row.DESCRIPCION,
    productBrand: row.MARCA,
    unitOfMeassure: row.MEDIDA,
    weightIndicator: row.PESO === 'S' ? 'Y' : 'N',
    estimatedWeight: row.PESO_ESTIMADO,
    price: row.PRECIO_LISTA || 0,
    taxPercentage: row.PORC_IMP,
    customerExclusive:  (row.ES_PROPIETARIO === 'NO' || row.ES_PROPIETARIO === null || row.ES_PROPIETARIO === undefined) ? 'N' : 'Y',    
    stock: row.SALDO,
    hasImages: row.TIENE_IMAGENES === 'S' ? true : false,
    urlImage: row.URLIMAGE || ''
});